var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDialerOff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.2027,
    cy: 20.2027,
    r: 5.2027,
    fill: "#909090"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5001,
    cy: 20.2027,
    r: 5.2027,
    fill: "#909090"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 44.7974,
    cy: 20.2027,
    r: 5.2027,
    fill: "#909090"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.2027,
    cy: 32.4999,
    r: 5.2027,
    fill: "#909090"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5001,
    cy: 32.4999,
    r: 5.2027,
    fill: "#909090"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 44.7974,
    cy: 32.4999,
    r: 5.2027,
    fill: "#909090"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.2027,
    cy: 44.7973,
    r: 5.2027,
    fill: "#909090"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5001,
    cy: 44.7973,
    r: 5.2027,
    fill: "#909090"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 44.7974,
    cy: 44.7973,
    r: 5.2027,
    fill: "#909090"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDialerOff);
export default __webpack_public_path__ + "static/media/dialerOff.9c3b34641a7a680a46816f551f2d03ca.svg";
export { ForwardRef as ReactComponent };